module.exports = __webpack_public_path__ + "static/img/10.fe8ab41.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/10.png
// module id = OQCH
// module chunks = 0